module.exports = __webpack_public_path__ + "img/northeast-spring-1920x550.d42b5ddb.jpg";